export default [
  {
    path: "/user-list",
    component: (resolve) => require(["@/vuepage/user-manage/index.vue"], resolve),
    meta: [
      {
        name: "用户管理",
      },
      {
        name: "用户列表",
        activeRoute: "/user-list",
      },
    ],
  },
  {
    path: "/user-detail",
    component: (resolve) => require(["@/vuepage/user-manage/detail.vue"], resolve),
    meta: [
      {
        name: "用户管理",
      },
      {
        name: "用户详情",
        activeRoute: "/user-list",
      },
    ],
  },
];
